import { FC, memo } from 'react'

import { Button, Text, Link } from '@cash-me/react-components'
import NextImage from "next/image"

import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { DescriptionProps } from './description.model'
import * as S from './styles'

const Description: FC<DescriptionProps> = memo(({ onClick }) => {
  const { isTablet } = useWindowSize()

  return (
    <S.Section>
      <Grid col={{ phone: 1, tablet: 2 }}>
        <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
          <S.ImageWrapper>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home-equity/home-equity.png`}
              alt="Homem sorrindo de braços cruzados"
              width="624"
              height="691"
              priority
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }} />
          </S.ImageWrapper>
        </Col>
        <Col col={{ desktop: 5 }} start={{ desktop: 7 }}>
          <S.Infos>
            <Text className="subtitle" size="caption" weight="medium" uppercase>
              Home equity
            </Text>
            <Text as="h2" size="heading3" weight="medium">
              <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
                O que é e como funciona{' '}
              </Text>
              o Home Equity?
            </Text>

            <Text color="var(--colors-neutral-text-weak)">
              Esse tipo de empréstimo, muito comum nos Estados Unidos, apresenta condições bastante atraentes: a
              instituição financeira concede o crédito a juros reduzidos ao proprietário, que utiliza o seu imóvel como
              garantia.
            </Text>

            <Text color="var(--colors-neutral-text-weak)">
              O Home Equity possibilita ao cliente conseguir mais recursos financeiros enquanto desfruta do imóvel
              colocado como aval. O diferencial nessa situação é o contrato, pois, nele é feita uma alienação
              fiduciária. <Link href="#alienacao-fiduciaria">Vamos entender o que é isso?</Link>
            </Text>
          </S.Infos>

          <Button
            size="lg"
            onClick={onClick}
            {...(isTablet ? { variants: 'default', iconName: 'arrowRight' } : { variants: 'text-only' })}
          >
            Simular agora
          </Button>
        </Col>
      </Grid>
    </S.Section>
  );
})

Description.displayName = 'Description'

export default Description
